<div *ngIf="reason" class="reason" (click)="selectReason()" [class.reason--selected]="selected">
  <div class="reason_name"
       [innerHtml]="reason.name | dynamicTranslation: languageCode | classByChar: (selected ? 'button-background-gradient-letter' : 'button-text-gradient-letter')">
  </div>
</div>
